import * as Dialog from '@radix-ui/react-dialog';
import * as React from 'react';
import './professional-context-form.scss';

interface Props {
  open: boolean;
  initialQuery: string;
  onClose: () => void;
  onSubmit: (suggestedValue: string) => void;
}

export function SuggestExpertiseDialog({
  open,
  initialQuery,
  onClose,
  onSubmit,
}: Props): React.ReactElement {
  const [value, setValue] = React.useState(initialQuery);

  React.useEffect(() => {
    if (open) setValue(initialQuery);
  }, [open, initialQuery]);

  const trimmed = value.trim();

  return (
    <Dialog.Root
      open={open}
      onOpenChange={(o) => {
        if (!o) onClose();
      }}
    >
      <Dialog.Portal>
        <Dialog.Overlay className="plan-c-form__dialog-overlay" />
        <Dialog.Content className="plan-c-form__dialog-content">
          <Dialog.Title className="plan-c-form__dialog-title">
            Suggest a new expertise area
          </Dialog.Title>
          <Dialog.Description className="plan-c-form__dialog-body">
            Don't see your field in the list? Tell us what you'd like to see and
            we'll review.
          </Dialog.Description>
          <input
            type="text"
            aria-label="Suggest a new expertise area"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className="plan-c-form__input"
            maxLength={80}
          />
          <div className="plan-c-form__dialog-actions">
            <button
              type="button"
              onClick={onClose}
              className="plan-c-form__button-secondary"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={() => {
                onSubmit(trimmed);
                onClose();
              }}
              disabled={trimmed.length === 0}
              className="plan-c-form__button-primary"
            >
              Submit
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
